export enum NotificationFilterType {
  All = 'all',
  Unread = 'unread',
  Mentions = 'mentions',
  AssignedToMe = 'assignedToMe',
  Unseen = 'unseen',
}
